export type Density = "compact" | "comfortable";

const STORAGE_KEY: string = "kuika:board:density";

export function getStoredDensity(): Density {
  try {
    const raw: string | null = window.localStorage.getItem(STORAGE_KEY);
    if (raw === "compact" || raw === "comfortable") return raw;
  } catch {
    // ignore
  }
  return "comfortable";
}

export function setStoredDensity(value: Density): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // ignore
  }
}
